
import styles from '../coverSection/coverSection.module.css';
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout';

export function CoverSection() {
  return (
    <section className={styles.coverContainer}>
      <MarkupLayout>
        <div className={styles.coverTextContainer}>
          <h2 className={styles.coverHeader}>
            <span>тормозные</span>
            <span style={{ display: 'block' }}>колодки</span>
          </h2>
          <p className={styles.coverParagraph}>
            Все, что нужно знать <br /> о тормозных колодках
          </p>
        </div>
      </MarkupLayout>
    </section>
  );
}
